export default __webpack_public_path__ + "static/media/2-produtos.78a4ed90.svg";